import React, { PropsWithChildren } from "react";
import { isBrowser, isMobile } from "react-device-detect";
import ReactModal from "react-modal";

import { ModalHeader, ModalStep } from "..";
import { joinClassNames } from "../../shared/Functions";
import { mobileModalStyles } from "../../styles/modalStyles";
import { ModalState } from "../../types";

type ModalProps = {
  modalState: ModalState;
  closeModal: () => void;
};

export const CustomModal: React.FC<PropsWithChildren<ModalProps>> = ({
  modalState,
  closeModal,
}: PropsWithChildren<ModalProps>) => {
  const screenWidth = window.innerWidth;
  const { shouldOpen, title, steps, singleStep } = modalState;

  // #root only exists in the real app shell (index.html) — Cypress's
  // component-test harness mounts into a differently-identified root, so
  // skip there rather than letting react-modal throw on a missing selector.
  if (document.getElementById("root")) {
    ReactModal.setAppElement("#root");
  }

  ReactModal.defaultStyles.overlay = {
    position: "fixed",
    zIndex: "9999",
    height: "100vh",
    width: "100vw",
    overflow: "auto",
    top: "0px",
    left: "0px",
    backgroundColor: "rgba(0, 0, 0, 0.4)",
    display: "block",
    transitionProperty: "all",
    transitionTimingFunction: "ease-in-out",
    transitionDuration: "0.4s",
    paddingTop: "45px",
    opacity: "1",
    marginBottom: "45px",
    border: "none",
  };

  ReactModal.defaultStyles.content = {
    fontFamily: "var(--font-body)",
    border: "none",
    borderRadius: "0.5rem",
    padding: "0",
    margin: "10vh auto 200px",
    height: "fit-content",
    width: "75%",
    maxWidth: "1052px",
    // default React Modal styles are added back here
    position: "absolute",
    top: "40px",
    left: "40px",
    right: "40px",
    bottom: "40px",
    background: "#fff",
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
    outline: "none",
  };

  const ModalComponent = ReactModal as any;

  return (
    <ModalComponent
      isOpen={shouldOpen}
      style={
        isMobile || (isBrowser && screenWidth < 1024) ? mobileModalStyles : {}
      }
    >
      <ModalHeader title={title} handleClose={closeModal} component="custom" />
      <div
        data-testid="custom-modal-body"
        className={joinClassNames(isMobile ? "h-[75%]" : "h-full")}
      >
        {steps && steps.length > 0 ? (
          <ModalStep steps={steps} />
        ) : (
          <div
            className="w-full relative mx-auto"
            data-testid="single-step-modal-contents"
          >
            {singleStep}
          </div>
        )}
      </div>
    </ModalComponent>
  );
};
